import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./SubmitButton.scss";

type SubmitButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  icon?: ReactNode;
};

export const SubmitButton = ({
  children,
  loading = false,
  disabled,
  icon,
  className = "",
  ...props
}: SubmitButtonProps) => {
  return (
    <button
      {...props}
      type="submit"
      disabled={disabled || loading}
      className={[
        "submit-button",
        loading ? "submit-button--loading" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="submit-button__shine" />

      <span className="submit-button__content">

        {loading ? (
          <span
            className="submit-button__spinner"
            aria-hidden="true"
          />
        ) : (
          icon && (
            <span
              className="submit-button__icon"
              aria-hidden="true"
            >
              {icon}
            </span>
          )
        )}

        <span>
          {loading
            ? "Küldés..."
            : children}
        </span>

      </span>
    </button>
  );
};